var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.454 26V8.805H.164V26h5.29zm0-23.29C5.423 1.172 4.402 0 2.743 0 1.084 0 0 1.172 0 2.71c0 1.506 1.052 2.711 2.68 2.711h.031c1.69 0 2.743-1.205 2.743-2.71zM14.086 26v-9.797c0-.524.037-1.048.19-1.422.42-1.048 1.376-2.133 2.98-2.133 2.1 0 3.418 1.197 3.418 3.555V26H26V15.941c0-5.388-2.864-7.896-6.683-7.896-3.132 0-4.507 1.76-5.27 2.956l.038-2.3H8.768c.076 1.646 0 17.299 0 17.299h5.318z","fill":"#6C40FD"}));
}

LinkedinIcon.defaultProps = {"width":"26","height":"26","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
